import { NovoTranslationApi } from './novo-translation-api.class';
import { NovoTranslationLoader } from './novo-translation.loader';

// AoT requires an exported function for factories
export const NovoTranslationLoaderFactory = (api: NovoTranslationApi, platform: string) => {
    return new NovoTranslationLoader(api, platform);
};

